import React from 'react'
import { ICharacter } from '../../../../../../../../api/types/character'
import makeStyles from '@mui/styles/makeStyles'
import { Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import { ModifyAttributeAction } from './components/ModifyAttributeAction/ModifyAttributeAction'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    actionButtons: {
      display: 'flex',
    },
    action: {
      margin: theme.spacing(0.5),
      flexGrow: 1,
    },
  })
)

interface Props {
  character: ICharacter
  game_id?: number
}

export const CharacterActions: React.FC<Props> = ({ game_id, character }) => {
  const classes = useStyles()
  return (
    <>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        Modyfikacja atrybutów
      </Typography>
      <div className={classes.actionButtons}>
        <ModifyAttributeAction
          game_id={game_id}
          character={character}
          name={'Modyfikacja punktów życia'}
          action_type="modify_hp"
          icon={<FavoriteBorderIcon />}
        />
        <ModifyAttributeAction
          game_id={game_id}
          character={character}
          name={'Modyfikacja punktów skupienia'}
          action_type="modify_mp"
          icon={<CenterFocusWeakIcon />}
        />
      </div>
    </>
  )
}
